import copyToClipboard from 'copy-to-clipboard';
import { useCallback, useMemo } from 'react';

import useAppDispatch from '~hooks/useAppDispatch';
import useLabels from '~hooks/useLabels';
import { AssetId } from '~modules/media-library/model/Asset';
import { getMamAssetUrl } from '~services/api/calls/mam-assets';
import { StatusActions } from '~store/actions';
import { makeProgramaticallyLinkClick } from '~utils/link';

export default function useAssetActions() {
  const dispatch = useAppDispatch();

  // Labels
  const { msgMediaLibraryCopyId } = useLabels(['msgMediaLibraryCopyId']);

  // Handler: copy asset id to clipboard
  const onCopyId = useCallback(
    (id: AssetId) => {
      const isCopied = copyToClipboard(id);
      if (isCopied) {
        dispatch(StatusActions.setSuccessNotification(msgMediaLibraryCopyId));
      }
    },
    [dispatch, msgMediaLibraryCopyId],
  );

  // Handler: onDownload fetches download url and gives it back
  const onDownload = useCallback(async (id: AssetId) => {
    const dto = await getMamAssetUrl(parseInt(id, 10));
    makeProgramaticallyLinkClick({ href: dto.url });
  }, []);

  return useMemo(
    () => ({
      onCopyId,
      onDownload,
    }),
    [onCopyId, onDownload],
  );
}
